import { isMobile } from '@flowwai-frontend/shared/utils/web'
import { AnimationProps } from 'framer-motion'

export const container =
   'flex gap-2 items-center absolute left-1/2 -translate-x-1/2 bottom-[32px] bg-white rounded-[16px] p-[6px] shadow-lg w-maxContent'

export const animationProps: AnimationProps = isMobile()
   ? {}
   : {
        initial: { translateY: 100, opacity: 0, translateX: '-50%' },
        animate: { translateY: 0, opacity: 1, translateX: '-50%' },
        transition: {
           type: 'spring',
           stiffness: 260,
           damping: 24,
           delay: 0.3
        }
     }

export const placesSearchAnimationProps: AnimationProps = isMobile()
   ? {}
   : {
        initial: { x: -100, opacity: 0 },
        animate: { x: 0, opacity: 1 },
        transition: {
           type: 'spring',
           stiffness: 260,
           damping: 24,
           delay: 0.3
        }
     }
